import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldAlert, ArrowRight, Home } from 'lucide-react';
import { useThemeStore } from '@/stores';

interface AccessDeniedProps {
  requiredPermission?: string;
  title?: string;
  message?: string;
}

export const AccessDenied: React.FC<AccessDeniedProps> = ({
  requiredPermission,
  title = 'غير مصرح بالوصول',
  message = 'ليس لديك الصلاحية الكافية للوصول إلى هذه الصفحة أو تنفيذ هذا الإجراء.',
}) => {
  const navigate = useNavigate();
  const theme = useThemeStore((s) => s.theme);
  const isLight = theme === 'light';

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 'calc(100vh - 120px)',
        padding: '24px',
        direction: 'rtl',
      }}
    >
      <div
        style={{
          maxWidth: '520px',
          width: '100%',
          background: isLight ? '#ffffff' : 'linear-gradient(180deg, rgba(13,31,60,0.9) 0%, rgba(10,22,40,0.95) 100%)',
          border: isLight ? '1px solid #e2e8f0' : '1px solid rgba(239, 68, 68, 0.25)',
          borderRadius: '16px',
          padding: '36px 28px',
          textAlign: 'center',
          boxShadow: isLight ? '0 10px 25px rgba(0,0,0,0.05)' : '0 12px 36px rgba(0,0,0,0.4)',
        }}
      >
        <div
          style={{
            width: '64px',
            height: '64px',
            borderRadius: '50%',
            background: 'rgba(239, 68, 68, 0.12)',
            border: '1px solid rgba(239, 68, 68, 0.3)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px auto',
            color: '#ef4444',
          }}
        >
          <ShieldAlert size={32} />
        </div>

        <h2
          style={{
            color: isLight ? '#0f172a' : '#f8fafc',
            fontSize: '20px',
            fontWeight: 700,
            marginBottom: '10px',
          }}
        >
          {title}
        </h2>

        <p
          style={{
            color: isLight ? '#64748b' : '#94a3b8',
            fontSize: '14px',
            lineHeight: 1.6,
            marginBottom: '20px',
          }}
        >
          {message}
        </p>

        {requiredPermission && (
          <div
            style={{
              display: 'inline-block',
              background: isLight ? 'rgba(239, 68, 68, 0.08)' : 'rgba(239, 68, 68, 0.15)',
              border: '1px dashed rgba(239, 68, 68, 0.35)',
              borderRadius: '8px',
              padding: '6px 14px',
              color: '#ef4444',
              fontSize: '12px',
              fontWeight: 600,
              marginBottom: '24px',
              direction: 'ltr',
            }}
          >
            {`Required: ${requiredPermission}`}
          </div>
        )}

        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '12px',
          }}
        >
          <button
            onClick={() => navigate('/')}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              background: 'linear-gradient(90deg, #3b82f6, #6366f1)',
              color: '#ffffff',
              border: 'none',
              borderRadius: '8px',
              padding: '10px 20px',
              fontSize: '14px',
              fontWeight: 600,
              cursor: 'pointer',
              transition: 'all 0.2s',
            }}
          >
            <Home size={16} />
            <span>العودة للرئيسية</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccessDenied;
